import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { PaymentDetailInfoService } from "../../services/payment-detail-info.service";
import { Subscription } from "rxjs";
import { PaymentDetailInfoDto, PaymentStatusDto } from "../../models/payment.models";
import { PaymentDataService } from "../../services/payment-data-service.service";
import { PaymentStatusService } from "../../services/payment-status.service";
import { ModalService } from "../../../../services/modal.service";
import { FileNameSetService } from "../../../../services/file-name-set.service";

@Component({
  selector: "app-payment-detail-dialog",
  templateUrl: "./payment-detail-dialog.component.html",
  styleUrls: ["./payment-detail-dialog.component.scss"],
})
export class PaymentDetailDialogComponent implements OnInit, OnDestroy {
  @Output() copyDetail: EventEmitter<void> = new EventEmitter<void>();
  @Output() statusUpdateEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild("modalBlock") modalBlock: ElementRef | undefined;

  subs: Subscription[] = [];

  paymentInfo: PaymentDetailInfoDto | undefined;

  text = "";

  paymentStatus: PaymentStatusDto | null | undefined;

  fileName = "";

  isLoadingStatus = false;

  isOpenAccordionOne = false;
  isOpenAccordionTwo = false;

  constructor(
    private paymentDetailInfoService: PaymentDetailInfoService,
    private paymentDataService: PaymentDataService,
    private paymentStatusService: PaymentStatusService,
    private modalService: ModalService,
    private fileNameSetService: FileNameSetService
  ) {}

  ngOnInit() {
    this.initModal();
    this.fileNameInit();
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  fileNameInit() {
    this.subs.push(
      this.fileNameSetService.setFileName$.subscribe({
        next: (res) => {
          this.fileName = res;
        },
      })
    );
  }

  initModal() {
    this.subs.push(
      this.paymentDetailInfoService.paymentDetail$.subscribe({
        next: (res) => {
          this.paymentInfo = res;
          setTimeout(() => {
            let arr: string[] = [];
            let allBlock = this.modalBlock?.nativeElement.querySelectorAll(".info-block__line");

            allBlock.forEach(
              (item: {
                querySelector: (arg0: string) => {
                  (): any;
                  new (): any;
                  innerText: any;
                };
              }) => {
                let left = item.querySelector(".info-block__line-left").innerText;
                let right = item.querySelector(".info-block__line-right").innerText;
                arr.push(`${left}: ${right} \n`);
              }
            );

            this.text = arr.join(" ");
          }, 0);
        },
      })
    );

    this.subs.push(
      this.modalService.isModalOpen$.subscribe({
        next: (res) => {
          if (!res) {
            this.paymentStatus = undefined;
            this.paymentInfo = undefined;
          }
        },
      })
    );
  }

  onClipboardCopy(event: boolean) {
    this.copyDetail.next();
  }

  getStatus() {
    this.isLoadingStatus = true;
    this.paymentDataService.getPaymentStatus(this.paymentInfo!.id).subscribe({
      next: (res) => {
        this.paymentStatus = res;
        this.paymentStatusService.paymentStatusService$.next(res);
        this.isLoadingStatus = false;
        this.statusUpdateEvent.emit();
      },
      error: () => {
        this.isLoadingStatus = false;
      },
    });
  }

  openAccordionOne() {
    if (this.paymentInfo?.claims.length) {
      this.isOpenAccordionOne = !this.isOpenAccordionOne;
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  downloadFiles(id: number) {
    this.paymentDataService.loadRefundFile(id).subscribe({
      next: (res) => {
        let link = document.createElement("a");
        link.href = (window.webkitURL || window.URL).createObjectURL(res);
        link.download = this.fileName;
        link.click();
      },
    });
  }
}
